import { useCallback } from 'react'

// Format "YYYY-MM-DD HH:mm"; returns "—" for invalid
const formatYMDHM = v => {
	if (!v) return '—'
	const d = new Date(v)
	if (Number.isNaN(d.getTime())) return '—'
	const pad = n => String(n).padStart(2, '0')
	return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
}

export default function ConsumptionHistoryTable({ rows = [], saving = false, onRemoveRow }) {
	const handleRemove = useCallback(
		e => {
			const idx = Number(e.currentTarget.dataset.index)
			onRemoveRow?.(idx)
		},
		[onRemoveRow]
	)

	const hasRows = Array.isArray(rows) && rows.length > 0

	return (
		<div className="px-4 sm:px-0">
			<div className="-mx-4 sm:mx-0 overflow-x-auto">
				<table className="w-max min-w-[720px] lg:w-full bg-white border-t border-b border-gray-200 rounded-lg">
					<colgroup>
						<col className="w-[14ch]" />
						<col className="w-[32ch]" />
						<col />
						<col className="w-[1%]" />
					</colgroup>

					<thead className="bg-gray-50">
						<tr>
							<th className="px-3 py-2 text-left text-sm font-medium text-gray-700">Date &amp; time</th>
							<th className="px-3 py-2 text-left text-sm font-medium text-gray-700">Service</th>
							<th className="px-3 py-2 text-right text-sm font-medium text-gray-700">Actions</th>
						</tr>
					</thead>

					<tbody>
						{!hasRows ? (
							<tr className="border-t border-gray-200">
								<td className="px-3 py-3 text-sm text-gray-500" colSpan={4}>
									No entries yet.
								</td>
							</tr>
						) : (
							rows.map((row, i) => {
								// console.log(`TCL -> ConsumptionHistoryTable.jsx:52 -> ConsumptionHistoryTable -> row:`, row)
								const key = row.id
								// console.log(`TCL -> ConsumptionHistoryTable.jsx:54 -> ConsumptionHistoryTable -> key:`, key)
								const when = formatYMDHM(row?.dateLocal || row?.date)
								return (
									<tr key={key} className="border-t border-gray-200">
										<td className="px-3 py-2 align-top">
											<div className="py-2.5 text-sm text-gray-900">{when}</div>
										</td>

										<td className="px-3 py-2 align-top">
											<div className="py-2.5 text-sm text-gray-900">{row?.service || '—'}</div>
										</td>

										<td className="px-3 py-2 text-right whitespace-nowrap">
											<button
												type="button"
												data-index={i}
												onClick={handleRemove}
												disabled={saving}
												className="px-3 py-1.5 text-sm bg-red-600 text-white rounded hover:bg-red-700 disabled:opacity-60 disabled:cursor-not-allowed"
												aria-label={`Remove usage row ${i + 1}`}>
												Remove
											</button>
										</td>
									</tr>
								)
							})
						)}
					</tbody>
				</table>
			</div>
		</div>
	)
}
